import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-442ef0a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" intro überspringen ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" los geht's ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_grid, { class: "ion-padding" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      "size-xs": "12",
                      "size-sm": "12",
                      "size-md": "12",
                      "size-lg": "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_swiper, {
                          class: "boarding-swiper",
                          modules: _ctx.modules,
                          pagination: true,
                          navigation: true,
                          keyboard: true
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, key) => {
                              return (_openBlock(), _createBlock(_component_swiper_slide, { key: key }, {
                                default: _withCtx(() => [
                                  (slide.image)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: slide.image
                                      }, null, 8, _hoisted_2))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_3, [
                                    (key === 0)
                                      ? (_openBlock(), _createBlock(_component_ion_button, {
                                          key: 0,
                                          expand: "block",
                                          color: "thing-tag",
                                          onClick: _ctx.goToHomePage
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_4
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"]))
                                      : (_openBlock(), _createBlock(_component_ion_button, {
                                          key: 1,
                                          expand: "block",
                                          color: "thing-tag",
                                          onClick: _ctx.goToHomePage
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_5
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"]))
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modules"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}